<template>
  <div>

    <div class="workspace">
      <div class="section-heading">
        <h2>Coupon Settings</h2>
        <a href="#"><div class="tr-button green-button" @click="isAdd = true"><i class="fas fa-plus"></i> New Coupon</div></a>
      </div>

      <div v-if="isAdd" id="new" class="show">
        <div class="coupon-top">
          <h3><i class="far fa-plus-square"></i> New Coupon</h3>
        </div>
        <div class="coup-list">
          <div class="coup-cont" data-vv-scope="edit">
          <div class="coup-column">
            <div class="coup-section-heading">Coupon Name</div>
            <input type="text" class="coup-input" v-model="name" name="Name"  v-validate="'required'">
            <span class="text-danger text-sm w-full" v-show="errors.has('edit.Name')">{{ errors.first('edit.Name') }}</span>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Coupon Code</div>
            <input type="text" class="coup-input" v-model="code" name="Code"  v-validate="'required'">
            <span class="text-danger text-sm w-full" v-show="errors.has('edit.Code')">{{ errors.first('edit.Code') }}</span>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Min. Order Total</div>
            <input type="text" class="coup-input" v-model="minValue" name="Min Order Total"  v-validate="'required'">
            <span class="text-danger text-sm w-full" v-show="errors.has('edit.Min Order Total')">{{ errors.first('edit.Min Order Total') }}</span>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Discount Amount</div>
            <input type="text" class="coup-input" v-model="value" name="Discount Amount"  v-validate="'required'">
            <span class="text-danger text-sm w-full" v-show="errors.has('edit.Discount Amount')">{{ errors.first('edit.Discount Amount') }}</span>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Discount Type</div>
            <label for="percent-edit">
              <input type="radio" id="percent-edit" v-model="type" name="discount-type" value="percent">
              Percent %</label>
            <label for="flat-edit">
              <input type="radio" id="flat-edit" v-model="type" name="discount-type" value="static">
              Flat Rate $</label>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Usage Count per Customer</div>
            <input type="text" class="coup-input" v-model="usage_per_customer">
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Coupon Start Date</div>
            <input type="date" class="coup-input" v-model="startDate">
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Coupon End Date</div>
            <input type="date" class="coup-input" v-model="endDate">
          </div>
          <div class="coup-column coup-edit">
            <h3 @click="submitSave"><i class="fas fa-save"></i> Save</h3>

            <h3 @click="isAdd = false" class="delete"><i class="fas fa-trash"></i> Cancel</h3>
          </div>
        </div>
        </div></div>
      <div class="active-coupons">
        <div class="coupon-top">
          <h3><i class="far fa-lightbulb on"></i> Active Coupons</h3>
        </div>
        <div class="coup-list">
          <promotion-item v-if="data.is_active" :key="indextr" v-for="(data, indextr) in coupons" :coupon-data="data" :updated="couponUpdated" />
        </div>
      </div>
      <div class="inactive-coupons">
        <div class="coupon-top">
          <h3><i class="far fa-lightbulb off"></i> Deactive Coupons</h3>
        </div>
        <div class="coup-list deactive">
          <promotion-item v-if="!data.is_active" :key="indextr" v-for="(data, indextr) in coupons" :coupon-data="data" :updated="couponUpdated" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import DataViewSidebar from './DataViewSidebar'
import PromotionItem from './PromotionItem'
import moment from 'moment'
export default {
  components: {
    vSelect,
    DataViewSidebar,
    PromotionItem
  },
  data () {
    return {
      restaurantId: -1,
      isMounted: false,
      isAdd: false,
      name: '',
      code: '',
      minValue: 0,
      value: 0,
      type: 'percent', //percent | static
      is_active: true,
      startDate: moment().format('yyyy-MM-DD'),
      startHour: '00:00',
      endDate: moment().format('yyyy-MM-DD'),
      endHour: '00:00',
      usage_per_customer: null
    }
  },
  computed: {
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    },
    coupons () {
      return this.$store.state.api.coupons
    }
  },
  watch: {
    '$store.state.api.selectedRestaurant' (val) {
      if (val) {
        this.restaurantId = this.selectedRestaurant.id
        this.getCouponList()
      }
    },
    isAdd () {
      if (!this.isAdd) {
        this.clearData()
      }
    }
  },
  methods: {

    clearData () {
      this.name = ''
      this.code = ''
      this.code = ''
      this.minValue = 0
      this.value = 0
      this.usage_per_customer = null
      this.type = 'percent' //percent | static
      this.is_active = true
      this.startDate = moment().format('yyyy-MM-DD')
      this.startHour = '00:00'
      this.endDate = moment().format('yyyy-MM-DD')
      this.endHour = '00:00'
    },
    submitSave () {
      this.$vs.loading()
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          const obj = {
            name: this.name,
            code: this.code,
            usage_per_customer: this.usage_per_customer,
            minValue: this.minValue,
            startDate: `${this.startDate} ${this.startHour}`,
            endDate: `${this.endDate} ${this.endHour}`,
            type: this.type,
            value: this.value,
            restaurantId: this.restaurantId,
            is_active: this.is_active
          }
          this.$store.dispatch('api/setCoupon', obj)
            .then(() => {
              this.getCouponList()
              this.isAdd = false
              this.$vs.loading.close()
            })
            .catch(err => {
              console.error(err)
              this.$vs.loading.close()
            })

        }
      })
    },
    couponUpdated (val) {
      if (val) {
        this.getCouponList()
      }
    },
    getCouponList () {
      const payload = {
        restaurantId: this.restaurantId
      }

      this.$vs.loading()

      this.$store.dispatch('api/getCouponList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  created () {
  },
  mounted () {
    this.isMounted = true

    if (this.selectedRestaurant) {
      this.restaurantId = this.selectedRestaurant.id
      this.getCouponList()
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0;
      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 20px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
